import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginUser, logoutUser } from "../store/actions";

/**
 * useAuth Hook
 * Centralizes authentication logic and session management.
 * 
 * @returns {Object} { user, loading, error, login, logout, isAuthenticated, role, empresaId }
 */
const useAuth = () => {
  const dispatch = useDispatch();
  const { error, loading } = useSelector((state) => state.Login);

  const login = useCallback(
    (values, history) => {
      dispatch(loginUser(values, history));
    },
    [dispatch]
  );

  const logout = useCallback(
    (history) => {
      dispatch(logoutUser(history));
    },
    [dispatch]
  );

  const isAuthenticated = !!sessionStorage.getItem("satiAuth");
  const role = sessionStorage.getItem("satiRol");
  const empresaId = sessionStorage.getItem("empresaId");

  return {
    loading,
    error,
    login,
    logout,
    isAuthenticated,
    role,
    empresaId,
  };
};

export default useAuth;
